import { createAction, createSlice } from "@reduxjs/toolkit";
// announcement banner
export const announcementInitialState = {
  divisions: [],
  loading: false,
  roles: [],
  announcmentreOccurenceFrequency: [],
  selectedTab: 1,
  addAnnouncementResponse: null,
  updateAnnouncementResponse: null,
  allAnnouncements: [],
  shownAnnouncements: 'all',
  historicalAnnouncementsList: [],
  historicalAnnouncementsListLoading: false,
  singleAnnouncementDetail: {},
  abortAnnouncementResponse: null,
  isRelaunchInitiated: false, // true in case of relaunch action from Historical announcement Tab
  selectedRadioActions:"all" // for All=.2, Active=>1, Inactive=>0

}
export const fetchDivisionsForAnnouncementCreator = createAction(
  'ANNOUNCEMENT_HANDLER/FETCH_DIVISIONS',
);
export const fetchDivisionsForAnnouncementTypeName =
  fetchDivisionsForAnnouncementCreator().type;

export const fetchRolesForAnnouncementCreator = createAction(
  'ANNOUNCEMENT_HANDLER/FETCH_ROLES',
);

export const fetchRolesForAnnouncementTypeName =
  fetchRolesForAnnouncementCreator().type;

export const fetchMessageReOccurenceForAnnouncementCreator = createAction(
  'ANNOUNCEMENT_HANDLER/FETCH_MSG_REOCCURENCE',
);

export const fetchMessageReOccurenceForAnnouncementTypeName =
  fetchMessageReOccurenceForAnnouncementCreator().type;

export const addAnnouncementCreator = createAction<any>(
  'ANNOUNCEMENT_HANDLER/ADD_ANNOUNCEMENT',
);


export const addAnnouncementCreatorTypeName =
  addAnnouncementCreator(null).type;


  export const fetchAllAnnouncementsCreator = createAction<any>(
  'ANNOUNCEMENT_HANDLER/FETCH_ALL_ANNOUNCEMENTS',
);

export const fetchAllAnnouncementsCreatorTypeName =
  fetchAllAnnouncementsCreator(null).type;

export const fetchHistoricalAnnouncementsCreator = createAction<any>(
  'ANNOUNCEMENT_HANDLER/FETCH_HISTORICAL_ANNOUNCEMENTS',
);
export const fetchHistoricalAnnouncementsCreatorTypeName =
  fetchHistoricalAnnouncementsCreator(null).type;

export const fetchSingleAnnouncementCreator = createAction<any>(
  'ANNOUNCEMENT_HANDLER/FETCH_SINGLE_ANNOUNCEMENT'
);
export const fetchSingleAnnouncementCreatorTypeName =
  fetchSingleAnnouncementCreator(null).type;

export const abortAnnouncementCreator = createAction<any>(
  'ANNOUNCEMENT_HANDLER/ABORT_ANNOUNCEMENT'
  );
export const abortAnnouncementCreatorTypeName =
abortAnnouncementCreator(null).type;

export const updateAnnouncementCreator = createAction<any>(
  'ANNOUNCEMENT_HANDLER/UPDATE_ANNOUNCEMENT',
);

export const updateAnnouncementCreatorTypeName =
updateAnnouncementCreator(null).type;

export const announcementStateHandler = createSlice({
  name: "ANNOUNCEMENT_HANDLER",
  initialState: announcementInitialState,
  reducers: {
    setAnnouncementDivisons: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        divisions: payload,
      };
    },
    setAnnouncementDivisonsLoading: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        loading: payload,
      };
    },
    setAnnouncementRoles: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        roles: payload,
      };
    },
    setMessageOccurence: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        announcmentreOccurenceFrequency: payload,
      };
    },
    setSelectedTab: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        selectedTab: payload,
      };
    },
    setAddAnnouncementResponse: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        addAnnouncementResponse: payload,
      };
    },
    setUpdateAnnouncementResponse: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        addAnnouncementResponse: payload,
      };
    },
    setAllAnnouncements: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        allAnnouncements: payload,
      };
    },

    setShownAnnouncements: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        shownAnnouncements: payload,
      };
    },

    setHistoricalAnnouncementsList: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        historicalAnnouncementsList: payload,
      };
    },

    setHistoricalAnnouncementsListLoading: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        historicalAnnouncementsListLoading: payload,
      };
    },

    setSingleAnnouncementDetail: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        singleAnnouncementDetail: payload,
      };
    },
    setAbortAnnouncementResponse: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        abortAnnouncementResponse: payload,
      };
    },
    setIsRelaunchInitiated: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        isRelaunchInitiated: payload,
      };
    },
    setSelectedRadioActions: (prevState, action) => {
      const { payload } = action;
      return {
        ...prevState,
        selectedRadioActions: payload,
      };
    },

  }
});
export const announcementStateActions = announcementStateHandler.actions;
export const announcementStateReducer = announcementStateHandler.reducer;